import React from 'react';

import Button from '@/components/common/Button/Button';
import { Modal } from '@/components/common/Modal/Modal';

interface ModalProps {
  isOpen: boolean;
  onRequestClose: () => void;
  children?: React.ReactNode;
}

export const CalorieModal: React.FC<ModalProps> = ({
  isOpen,
  onRequestClose,
  children,
}: ModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      headerTitle={''}
      customContentStyles={{ maxWidth: 400 }}
      onRequestClose={onRequestClose}
    >
      <div className="mx-auto w-auto max-w-sm p-8 text-center font-inter text-base md:text-xl lg:max-w-sm">
        {children}
        <div className="flex justify-center">
          <Button theme="tertiary" type="button" onClick={onRequestClose}>
            <span className="px-2">Okay</span>
          </Button>
        </div>
      </div>
    </Modal>
  );
};
